// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ninXB","tab":"styles_tab__7lwoO","tabActive":"styles_tabActive__XcfzQ","tabDisable":"styles_tabDisable__3qcTx","iconWrap":"styles_iconWrap__3Z2UC"};